/** „Sprzedaż PH” strings (`repSales.*`), merged in `i18n/extra.ts`. `repSalesEn` is typed against `repSalesPl`. */
type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const repSalesPl = {
  nav: 'Sprzedaż PH',
  title: 'Sprzedaż PH',
  subtitle: 'Zestawienie handlowca: sprzedaż i marża z 3 miesięcy, cel miesiąca, komentarze do klientów. Co tydzień trafia na aplikację handlowca (powiadomienie), opcjonalnie e-mailem z Excelem.',
  owner: 'Handlowiec',
  ownerSearch: 'Szukaj handlowca…',
  ownerNone: 'Brak handlowców',
  month: 'Miesiąc',
  download: 'Excel',
  search: 'Szukaj klienta lub trasy…',
  hero: {
    team: 'kier. {name}',
    noTeam: 'bez kierownika',
    routes: 'trasy: {list}',
    noRoutes: 'bez tras',
    customers: '{count} klientów',
    dataAsOf: 'dane na {time} (import ERP)',
    noImport: 'brak importu ERP',
    salesIn: 'Sprzedaż w {month}',
    salesPrev: '{month}: {value}',
    realization: 'Realizacja celu',
    missing: 'brakuje {value}',
    reached: 'cel osiągnięty',
    noTarget: 'brak celu',
    daily: 'Średni dzienny wywóz do celu',
    deliveryDays: '{count} dni dostaw',
    monthClosed: 'miesiąc zamknięty',
    margin: 'Średnia marża (3 mies.)',
    threshold: 'próg {pct}%',
    comments: 'Komentarze do spadków',
    commentsMissing: 'bez komentarza: {count}',
    commentsDone: 'wszystkie uzupełnione',
  },
  cards: {
    targetPct: '{pct} celu',
    noTarget: 'bez celu',
    comments: '{done}/{need} kom.',
    commentsDone: 'komentarze ✓',
    stripLabel: 'Handlowcy w Twoim zakresie',
  },
  target: {
    title: 'Cel miesiąca',
    hint: 'jak w arkuszu: 90% i 100% celu',
    level: '{pct}% celu',
    target: 'Target',
    realized: 'Zrealizowano (kwotowo)',
    realizedPct: 'Zrealizowano (procentowo)',
    remaining: 'Do zrobienia (kwotowo)',
    remainingPct: 'Do zrobienia (procentowo)',
    daysLeft: 'Dni dostaw zostało do końca miesiąca',
    daily: 'Średni dzienny wywóz do zrealizowania targetu',
    none: 'Brak celu na ten miesiąc',
    noneHint: 'Cel handlowca na ten miesiąc nie został wprowadzony — pokazujemy samą sprzedaż miesiąca.',
    dailyNone: '—',
    daysDef: 'Dni dostaw = dni robocze (pn–pt, bez świąt) od dziś włącznie do końca miesiąca.',
  },
  customers: {
    title: 'Klienci',
    hintCurrent: 'bieżący miesiąc',
    hintMonth: '{month}',
    count: 'Liczba klientów',
    notOrdered: 'Nie zamówiło w tym miesiącu',
    fresh: 'Nowych / odzyskanych',
  },
  legend: {
    title: 'Legenda',
    hint: 'jak w arkuszu',
    sales: 'Sprzedaż',
    salesHint: '(liczona w total, w PLN; kolor kolumny {month})',
    margin: 'Marża',
    marginHint: '(średnia z zamkniętych FV)',
    drop: 'Spadek',
    growth: 'Wzrost',
    bigDrop: 'Duży spadek / brak sprzedaży !!!',
    fresh: 'Nowy / odzyskany',
    lowMargin: 'Poniżej {pct}% / brak',
  },
  structure: {
    title: 'Struktura sprzedaży',
    hint: 'udział klientów',
    item: '{label} {pct}%',
  },
  trend: {
    GROWTH: 'Wzrost',
    DROP: 'Spadek',
    BIG_DROP_OR_NONE: 'Duży spadek / brak',
    NEW: 'Nowy / odzyskany',
    FLAT: 'Bez zmian',
  },
  sheet: {
    title: 'Arkusz klientów',
    hint: 'kliknij wiersz → panel klienta z wykresem i komentarzem',
    groupByRoute: 'Grupuj: trasa',
    noRoute: 'Bez trasy',
  },
  filters: {
    label: 'Filtr szybki',
    all: 'Wszyscy',
    drop: 'Spadek',
    bigDrop: 'Duży spadek / brak',
    growth: 'Wzrost',
    fresh: 'Nowi',
    lowMargin: 'Marża < {pct}%',
    noComment: 'Bez komentarza',
    since: 'Zmiany od {day}',
  },
  col: {
    customer: 'Klient',
    route: 'Trasa',
    sales: 'Sprzedaż',
    margin: 'Śr. marża',
    comment: 'Komentarz handlowca',
    sort: 'Sortuj: {col}',
    marginNone: 'brak',
  },
  total: 'Razem ({count})',
  mtd: 'do dziś',
  empty: 'Brak klientów w zestawieniu.',
  emptyFiltered: 'Żaden klient nie pasuje do filtrów.',
  needComment: {
    DROP: 'wymagany komentarz (spadek)',
    BIG_DROP_OR_NONE: 'wymagany komentarz (duży spadek)',
    margin: 'wymagany komentarz (marża)',
  },
  drawer: {
    months: 'Sprzedaż i marża — 3 miesiące',
    avgMargin: 'Średnia marża 3 mies.',
    total: 'Razem 3 mies.',
    comment: 'Komentarz handlowca',
    readOnly: 'Nie masz uprawnień do edycji komentarza.',
    openCard: 'Karta klienta',
    close: 'Zamknij',
  },
  comment: {
    placeholder: 'Dodaj komentarz…',
    save: 'Zapisz',
    saving: 'Zapisywanie…',
    saved: 'Komentarz zapisany',
    error: 'Nie udało się zapisać komentarza',
    by: '{name}, {when}',
    tooLong: 'Maksymalnie {max} znaków',
  },
};

export const repSalesEn: Shape<typeof repSalesPl> = {
  nav: 'Rep sales sheet',
  title: 'Rep sales sheet',
  subtitle: 'Sales rep sheet: 3 months of sales and margin, monthly target, comments per customer. Sent to the rep app every week (notification), optionally by e-mail with Excel.',
  owner: 'Sales rep',
  ownerSearch: 'Search sales rep…',
  ownerNone: 'No sales reps',
  month: 'Month',
  download: 'Excel',
  search: 'Search customer or route…',
  hero: {
    team: 'manager {name}',
    noTeam: 'no manager',
    routes: 'routes: {list}',
    noRoutes: 'no routes',
    customers: '{count} customers',
    dataAsOf: 'data as of {time} (ERP import)',
    noImport: 'no ERP import yet',
    salesIn: 'Sales in {month}',
    salesPrev: '{month}: {value}',
    realization: 'Target realization',
    missing: '{value} to go',
    reached: 'target reached',
    noTarget: 'no target',
    daily: 'Average daily sales to target',
    deliveryDays: '{count} delivery days',
    monthClosed: 'month closed',
    margin: 'Average margin (3 mo.)',
    threshold: 'threshold {pct}%',
    comments: 'Comments on drops',
    commentsMissing: 'missing: {count}',
    commentsDone: 'all done',
  },
  cards: {
    targetPct: '{pct} of target',
    noTarget: 'no target',
    comments: '{done}/{need} comm.',
    commentsDone: 'comments ✓',
    stripLabel: 'Sales reps in your scope',
  },
  target: {
    title: 'Monthly target',
    hint: 'as in the workbook: 90% and 100% of target',
    level: '{pct}% of target',
    target: 'Target',
    realized: 'Achieved (amount)',
    realizedPct: 'Achieved (percent)',
    remaining: 'To go (amount)',
    remainingPct: 'To go (percent)',
    daysLeft: 'Delivery days left this month',
    daily: 'Average daily sales needed for the target',
    none: 'No target for this month',
    noneHint: 'No target has been entered for this rep and month — only the month sales are shown.',
    dailyNone: '—',
    daysDef: 'Delivery days = working days (Mon–Fri, no public holidays) from today inclusive to the month end.',
  },
  customers: {
    title: 'Customers',
    hintCurrent: 'current month',
    hintMonth: '{month}',
    count: 'Customers',
    notOrdered: 'No order this month',
    fresh: 'New / recovered',
  },
  legend: {
    title: 'Legend',
    hint: 'as in the workbook',
    sales: 'Sales',
    salesHint: '(total, in PLN; colour of the {month} column)',
    margin: 'Margin',
    marginHint: '(average of closed invoices)',
    drop: 'Drop',
    growth: 'Growth',
    bigDrop: 'Big drop / no sales !!!',
    fresh: 'New / recovered',
    lowMargin: 'Below {pct}% / missing',
  },
  structure: {
    title: 'Sales structure',
    hint: 'share of customers',
    item: '{label} {pct}%',
  },
  trend: {
    GROWTH: 'Growth',
    DROP: 'Drop',
    BIG_DROP_OR_NONE: 'Big drop / none',
    NEW: 'New / recovered',
    FLAT: 'Flat',
  },
  sheet: {
    title: 'Customer sheet',
    hint: 'click a row → customer panel with chart and comment',
    groupByRoute: 'Group: route',
    noRoute: 'No route',
  },
  filters: {
    label: 'Quick filter',
    all: 'All',
    drop: 'Drop',
    bigDrop: 'Big drop / none',
    growth: 'Growth',
    fresh: 'New',
    lowMargin: 'Margin < {pct}%',
    noComment: 'No comment',
    since: 'Changes since {day}',
  },
  col: {
    customer: 'Customer',
    route: 'Route',
    sales: 'Sales',
    margin: 'Avg. margin',
    comment: 'Rep comment',
    sort: 'Sort: {col}',
    marginNone: 'none',
  },
  total: 'Total ({count})',
  mtd: 'to date',
  empty: 'No customers in the sheet.',
  emptyFiltered: 'No customer matches the filters.',
  needComment: {
    DROP: 'comment required (drop)',
    BIG_DROP_OR_NONE: 'comment required (big drop)',
    margin: 'comment required (margin)',
  },
  drawer: {
    months: 'Sales and margin — 3 months',
    avgMargin: 'Average margin 3 mo.',
    total: 'Total 3 mo.',
    comment: 'Rep comment',
    readOnly: 'You cannot edit the comment.',
    openCard: 'Customer card',
    close: 'Close',
  },
  comment: {
    placeholder: 'Add a comment…',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Comment saved',
    error: 'Could not save the comment',
    by: '{name}, {when}',
    tooLong: 'At most {max} characters',
  },
};
